import { InView, UpdateParams } from "./../model/address";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { Address } from "../model/address";
import * as services from "../services/addressService";

export const fetchAddressesInContact = createAsyncThunk("addressManager/fetchAddressesInContact", (contactId: string) =>
    services.fetchAddressesInContact(contactId)
);

export const fetchAddressesInOrganization = createAsyncThunk(
    "addressManager/fetchAddressesInOrganization",
    (orgId: string) => services.fetchAddressesInOrganization(orgId)
);

export const fetchAddressById = createAsyncThunk("addressForm/fetchAddressById", (id: string) =>
    services.fetchAddressById(id)
);

export const updateAddress = createAsyncThunk(
    "addressManager/updateAddress",
    async (params: UpdateParams): Promise<Address[]> => {
        await services.updateAddress(params.address);
        let addresses = [] as Address[];
        if (params.inView === InView.Contact && params.address.contactId != null) {
            addresses = await services.fetchAddressesInContact(params.address.contactId);
        } else if (params.inView === InView.Organization && params.address.organizationId != null) {
            addresses = await services.fetchAddressesInOrganization(params.address.organizationId);
        }
        return addresses;
    }
);